const state = () => ({
    users:[
    ],
    avatres:{
        0:require(`@/assets/img/avatres/BobaFett.png`),
        1:require(`@/assets/img/avatres/DarthVader.png`),
        2:require(`@/assets/img/avatres/GeraltOfRivia.png`),
        3:require(`@/assets/img/avatres/CirillaRiannon.png`),
        4:require(`@/assets/img/avatres/YenefferOfVengerberg.png`),
        5:require(`@/assets/img/avatres/Triss.png`),
        6:require(`@/assets/img/avatres/Cloud.png`),
        7:require(`@/assets/img/avatres/Aeris.png`),
        8:require(`@/assets/img/avatres/Barrett.png`),
        9:require(`@/assets/img/avatres/Tifa.png`),

    },
    backupUser:{
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        createdAt:"",
        last_update:"",
        eneble:true,
        role:"CONSUMER",
    },
    user :{
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        createdAt:"",
        last_update:"",
        eneble:true,
        role:"CONSUMER",
        status:""
    },
    newUser :{
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        role:'CONSUMER',
    },
    perfil:{
        admin:1,
        padrao:0
    },
    userPerfil:[
        {  
            name:"Administrador",
            descrptions:"Acesso a todas as páginas administrativas da plataforma, como por exemplo edição do tema, gerenciamento de usuários, APIs, categorias, entre outros.",
            value: 'ADMIN',
            checked:false,
        },
        {
            name:"Padrão",
            descrptions:"Acesso comum dos usuários que se cadastram para consumir as APIs.",
            value: 'CONSUMER',
            checked: true,
        }
    ],
    newUserLabel:{
        title:"Criar novo usuário",
        descrptions:"Forneça os dados básicos da conta do usuário."
    },
    perfilUserLabel:{
        title:"Perfil do usuário",
        descrptions:"Escolha o perfil do usuário para determinar os acessos que a usuário terá na plataforma."
    },
    apisUserLabel:{
        title:"APIs consumidas",
        descrptions:"Informações das APIs consumidas pelo usuário selecionado."
    },
    dadoGeraisLabel:{
        title:"Dados gerais",
        descrptions:"Gerencie os dados básicos da conta do usuário."
    },
    statusLabel:{
        'Pendente':"Pendente",
        'Ativo':"Ativo",
        'Bloqueado':"Bloqueado",
    },
    statusColor:{
        'Pendente':"#404554",
        'Ativo':"#156A41",
        'Bloqueado':"#870400",
    },
    perfil:{
        CONSUMER:"Padrão",
        ADMIN:"Administrativo",
        
    },
    apisConsumed:[],
    ambience:{
        SANDBOX:"sandBox",
        PRODUCTION:"Produção"
    },
    headerApis:[
        {
            text: "API",
            value: "api",

        },
        {
            text: "Ambiente",
            value: "type",

        },
        {
            text: "Chave de integração",
            sortable: false,
            value: "apiKey",

        },
    ],
    headerUsres:
        [
            {
                text: "Avatar",
                sortable: false,
                value: "avatar",
                align: "start",

            },
            {
                text: "Nome",
                value: "fullName",             
            },
            {
                text: "Status", value: "status" , 
            },
            {
                text: "E-mail", value: "email" , 
            },
            {
                text: "Perfil", value: "perfil" ,
            },
            {
                text: "Chaves geradas", value: "chaves" , sortable: false , 
            },
            {
                text: "", value: "actions", sortable: false  ,align: "end",
            },
        ],
    labelsFisica:{
        name:"Nome",
        lastName:"Sobrenome",
        cpf:"Cpf",
        email:"E-mail",
        phone:"Telefone",
        createdAt:"Data de criação",
        last_update:"Última alteração",
        status:"Status: "
    },
    labelsJuridica:{
        name:"Nome do Responsável",
        lastName:"Sobrenome do Responsável",
        cnpj:"Cnpj",
        corporateName:"Razão Social",
        fantasyNName:"Nome Fantasia",
        email:"E-mail",
        phone:"Telefone",
        createdAt:"Data de criação",
        last_update:"Última alteração",
        status:"Status: "
    },
});
export default state;
